import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import CompareTable from "./CompareTable";

interface ICompare {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  selectedItemsToCompare: Array<any>;
  travelDistance: number;
}

function Compare(props: ICompare) {
  const { selectedItemsToCompare, travelDistance } = props;
  return (
    <>
      <h3 className="text-left styled-font styled-font">
        Compare your selections
      </h3>
      <CompareTable
        items={selectedItemsToCompare}
        travelDistance={travelDistance}
      />
    </>
  );
}

export default Compare;
